import React, { memo } from 'react';
import { Chip } from '@mui/material';
import type { ShiftSlotStatus } from '../../../../domain/dailyShiftSlot';
import { SHIFT_SLOT_STATUS_LABELS } from '../../../../domain/dailyShiftSlot';

/**
 * StatusChip のProps型
 *
 * @property {ShiftSlotStatus} status - 表示するステータス値
 */
interface Props {
  status: ShiftSlotStatus;
}

/**
 * ステータスと色のマッピング
 *
 * @description 各ステータスに対応するMUI Chipの色を定義
 */
const STATUS_COLORS: Record<ShiftSlotStatus, 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'> = {
  draft: 'default',
  recruiting: 'primary',
  closed: 'warning',
  confirmed: 'success'
};

/**
 * ステータス表示チップコンポーネント
 *
 * @description
 * シフト枠のステータスを色分けしたChipで表示する。
 * - 設定中（draft）: デフォルト（グレー）
 * - 募集中（recruiting）: プライマリ（青）
 * - 締切（closed）: 警告（オレンジ）
 * - 確定（confirmed）: 成功（緑）
 *
 * @param {Props} props - コンポーネントProps
 * @returns {React.ReactElement} ステータスチップ
 */
const StatusChip: React.FC<Props> = memo(({ status }) => {
  return (
    <Chip
      label={SHIFT_SLOT_STATUS_LABELS[status]}
      size="small"
      color={STATUS_COLORS[status]}
      variant="outlined"
    />
  );
});

StatusChip.displayName = 'StatusChip';

export default StatusChip;
